<template>
  <el-container class="default-layout">
    404
    <i class="el-icon-edit"></i>
    <i class="el-icon-share"></i>
    <i class="el-icon-delete"></i>
    <el-button type="primary" icon="el-icon-search">Search</el-button>
  </el-container>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goBack () {
      this.$router.push({ name: 'cpanel.dashboard' })
    }
  },
  created () {
    document.title = '404 - не найдено'
  }
}
</script>

<style scoped lang="scss">
</style>
